/**
 * Runtime module gates for invoices and projects (business_info flags).
 */
export function isInvoicesFeatureActive (businessInfo) {
  return businessInfo?.invoices_enabled !== false
}

export function isProjectsFeatureActive (businessInfo) {
  return !!businessInfo?.projects_enabled && isInvoicesFeatureActive(businessInfo)
}
